var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconawesomeHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60.12,
    height: 46.75,
    viewBox: "0 0 60.12 46.75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-home",
    "data-name": "Icon awesome-home",
    d: "M29.262,14.382,10.02,30.23v17.1A1.67,1.67,0,0,0,11.69,49l11.7-.03a1.67,1.67,0,0,0,1.662-1.67V37.316a1.67,1.67,0,0,1,1.67-1.67H33.4a1.67,1.67,0,0,1,1.67,1.67V47.3a1.67,1.67,0,0,0,1.67,1.675L48.427,49a1.67,1.67,0,0,0,1.67-1.67V30.219L30.859,14.382A1.272,1.272,0,0,0,29.262,14.382ZM59.657,25.154l-8.725-7.192V3.506a1.252,1.252,0,0,0-1.252-1.252H43.835a1.252,1.252,0,0,0-1.252,1.252v7.578L33.238,3.4a5.01,5.01,0,0,0-6.366,0L.453,25.154a1.252,1.252,0,0,0-.167,1.764l2.661,3.235a1.252,1.252,0,0,0,1.765.17L29.262,10.1a1.272,1.272,0,0,1,1.6,0l24.55,20.22a1.252,1.252,0,0,0,1.764-.167l2.661-3.235a1.252,1.252,0,0,0-.177-1.767Z",
    transform: "translate(0.001 -2.254)",
    fill: "#a1a3ef"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconawesomeHome);
export default __webpack_public_path__ + "static/media/Iconawesome-home.e153e84e1eed664d16a3aeadff7f5ac0.svg";
export { ForwardRef as ReactComponent };